import React from "react";

// components
import { Card, CardBody, CardFooter, Button, Row, Col, } from "reactstrap";

// views
import RelMapaEntrada from "./Fichas/RelMapaEntrada";
import RelGuiaDestinacao from "./Fichas/RelGuiaDestinacao";

export default function ListaRelatorios({ history }) {

  const list_table = [
    {
      title: "Mapa de Entrada",
      description: "Relatório detalhado de mapa de entradas.",
      component: (<RelMapaEntrada handleReturn={() => set_showFicha(false)} />)
    },
    {
      title: "Destinação",
      description: "Relatório detalhado de guias de destinação.",
      component: (<RelGuiaDestinacao handleReturn={() => set_showFicha(false)} />)
    }
  ];

  const [showFicha, set_showFicha] = React.useState(false);
  const [ficha, set_ficha] = React.useState(null);

  const handleFicha = (component) => {
    set_showFicha(true);
    set_ficha(component);
  }

  return (
    <>
      {!showFicha &&
        <div className="content">
          <Row>
            {list_table.map((m, key) => (
              <Col key={key} lg="4" md="6" sm="12">
                <Card>
                  <CardBody className="rel-card-body">
                    <h5>{m.title}</h5>
                    {m.description}
                  </CardBody>
                  <CardFooter className="text-right">
                    <Button color="warning" className="btn-mobile" onClick={() => handleFicha(m.component)}>Visualizar Relatório</Button>
                  </CardFooter>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      }
      {showFicha &&
        ficha
      }
    </>
  );
}

